
export const RedundancySvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_782_157129)">
            <path d="M6.66665 12H3.33331C2.80288 12 2.29417 11.7893 1.9191 11.4143C1.54403 11.0392 1.33331 10.5305 1.33331 10V9.33337" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.66669 14L6.66669 12L4.66669 10" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3333 9.33337H10.6666C9.93027 9.33337 9.33331 9.93033 9.33331 10.6667V13.3334C9.33331 14.0698 9.93027 14.6667 10.6666 14.6667H13.3333C14.0697 14.6667 14.6666 14.0698 14.6666 13.3334V10.6667C14.6666 9.93033 14.0697 9.33337 13.3333 9.33337Z" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.33331 1.33337H2.66665C1.93027 1.33337 1.33331 1.93033 1.33331 2.66671V5.33337C1.33331 6.06975 1.93027 6.66671 2.66665 6.66671H5.33331C6.06969 6.66671 6.66665 6.06975 6.66665 5.33337V2.66671C6.66665 1.93033 6.06969 1.33337 5.33331 1.33337Z" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_782_157129">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const ListSvg = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 3L5.125 3L5.125 6.125L2 6.125L2 3ZM2 11.1257L5.125 11.1257L5.125 14.2507L2 14.2507L2 11.1257ZM22 19.2503L2 19.2503L2 21.7503L22 21.7503L22 19.2503ZM7.62505 3L10.75 3L10.75 6.125L7.62505 6.125L7.62505 3ZM10.75 11.1257L7.62505 11.1257L7.62505 14.2507L10.75 14.2507L10.75 11.1257ZM13.25 3L16.375 3L16.375 6.125L13.25 6.125L13.25 3ZM16.375 11.1257L13.25 11.1257L13.25 14.2507L16.375 14.2507L16.375 11.1257ZM18.875 3L22 3L22 6.125L18.875 6.125L18.875 3ZM22 11.1257L18.875 11.1257L18.875 14.2507L22 14.2507L22 11.1257Z"
            fill="#D2D2D2"
        />
    </svg>
)


export const DbFileSvg = () => (
    <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 9.5C2 9.813 2.461 10.358 3.53 10.893C4.914 11.585 6.877 12 9 12C11.123 12 13.086 11.585 14.47 10.893C15.539 10.358 16 9.813 16 9.5V7.329C14.35 8.349 11.827 9 9 9C6.173 9 3.65 8.348 2 7.329V9.5ZM16 12.329C14.35 13.349 11.827 14 9 14C6.173 14 3.65 13.348 2 12.329V14.5C2 14.813 2.461 15.358 3.53 15.893C4.914 16.585 6.877 17 9 17C11.123 17 13.086 16.585 14.47 15.893C15.539 15.358 16 14.813 16 14.5V12.329ZM0 14.5V4.5C0 2.015 4.03 0 9 0C13.97 0 18 2.015 18 4.5V14.5C18 16.985 13.97 19 9 19C4.03 19 0 16.985 0 14.5ZM9 7C11.123 7 13.086 6.585 14.47 5.893C15.539 5.358 16 4.813 16 4.5C16 4.187 15.539 3.642 14.47 3.107C13.086 2.415 11.123 2 9 2C6.877 2 4.914 2.415 3.53 3.107C2.461 3.642 2 4.187 2 4.5C2 4.813 2.461 5.358 3.53 5.893C4.914 6.585 6.877 7 9 7Z"
            fill="#ABAEAF"
        />
    </svg>
)

export const CommsSvg = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.99953 11.0002L15.9995 20.0002H3.99953L9.99953 11.0002ZM9.99953 14.6002L7.73953 18.0002H12.2595L9.99953 14.6002ZM8.93953 8.5602C8.79216 8.42288 8.67395 8.25728 8.59197 8.07328C8.50998 7.88928 8.4659 7.69065 8.46235 7.48925C8.45879 7.28784 8.49584 7.08778 8.57128 6.90101C8.64673 6.71423 8.75902 6.54456 8.90145 6.40213C9.04389 6.25969 9.21356 6.1474 9.40033 6.07196C9.58711 5.99652 9.78717 5.95947 9.98857 5.96302C10.19 5.96657 10.3886 6.01066 10.5726 6.09264C10.7566 6.17462 10.9222 6.29283 11.0595 6.4402C11.3245 6.72455 11.4687 7.10065 11.4619 7.48925C11.455 7.87785 11.2976 8.24862 11.0228 8.52345C10.7479 8.79827 10.3772 8.9557 9.98857 8.96255C9.59997 8.96941 9.22388 8.82516 8.93953 8.5602ZM3.28053 0.783203L4.69553 2.1982C3.28919 3.6047 2.49913 5.51223 2.49913 7.5012C2.49913 9.49018 3.28919 11.3977 4.69553 12.8042L3.28053 14.2192C2.39823 13.337 1.69834 12.2897 1.22083 11.137C0.743329 9.98433 0.497559 8.74888 0.497559 7.5012C0.497559 6.25353 0.743329 5.01808 1.22083 3.86539C1.69834 2.71271 2.39823 1.66538 3.28053 0.783203ZM16.7165 0.783203C17.5988 1.66538 18.2987 2.71271 18.7762 3.86539C19.2537 5.01808 19.4995 6.25353 19.4995 7.5012C19.4995 8.74888 19.2537 9.98433 18.7762 11.137C18.2987 12.2897 17.5988 13.337 16.7165 14.2192L15.3015 12.8042C16.7079 11.3977 17.4979 9.49018 17.4979 7.5012C17.4979 5.51223 16.7079 3.6047 15.3015 2.1982L16.7165 0.783203ZM6.10953 3.6112L7.52353 5.0252C7.19849 5.35021 6.94065 5.73607 6.76473 6.16073C6.58882 6.58539 6.49828 7.04055 6.49828 7.5002C6.49828 7.95986 6.58882 8.41502 6.76473 8.83968C6.94065 9.26434 7.19849 9.65019 7.52353 9.9752L6.10953 11.3892C5.07813 10.3578 4.4987 8.95885 4.4987 7.5002C4.4987 6.04156 5.07813 4.64265 6.10953 3.6112ZM13.8875 3.6112C14.9189 4.64265 15.4984 6.04156 15.4984 7.5002C15.4984 8.95885 14.9189 10.3578 13.8875 11.3892L12.4735 9.9752C12.7986 9.65019 13.0564 9.26434 13.2323 8.83968C13.4082 8.41502 13.4988 7.95986 13.4988 7.5002C13.4988 7.04055 13.4082 6.58539 13.2323 6.16073C13.0564 5.73607 12.7986 5.35021 12.4735 5.0252L13.8875 3.6112Z"
            fill="#D2D2D2"
        />
    </svg>
)

export const BatterySvg = () => (
    <svg
        width="21"
        height="14"
        viewBox="0 0 21 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.99951 14.0002H0.999512C0.734295 14.0002 0.479941 13.8949 0.292405 13.7074C0.104869 13.5198 -0.000488281 13.2655 -0.000488281 13.0002V1.00024C-0.000488281 0.735028 0.104869 0.480674 0.292405 0.293138C0.479941 0.105601 0.734295 0.000244141 0.999512 0.000244141H7.62451L6.45751 2.00024H1.99951V12.0002H5.99951V14.0002ZM10.3745 14.0002L11.5415 12.0002H15.9995V2.00024H11.9995V0.000244141H16.9995C17.2647 0.000244141 17.5191 0.105601 17.7066 0.293138C17.8942 0.480674 17.9995 0.735028 17.9995 1.00024V13.0002C17.9995 13.2655 17.8942 13.5198 17.7066 13.7074C17.5191 13.8949 17.2647 14.0002 16.9995 14.0002H10.3745ZM18.9995 4.00024H20.9995V10.0002H18.9995V4.00024ZM9.99951 6.00025H12.9995L7.99951 14.0002V8.00025H4.99951L9.99951 0.000244141V6.00025Z"
            fill="#D2D2D2"
        />
    </svg>
)

export const PanelSvg = () => (
    <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 16.5V6.5H2V16.5H9ZM9 4.5V1.5C9 1.23478 9.10536 0.98043 9.29289 0.792893C9.48043 0.605357 9.73478 0.5 10 0.5H19C19.2652 0.5 19.5196 0.605357 19.7071 0.792893C19.8946 0.98043 20 1.23478 20 1.5V17.5C20 17.7652 19.8946 18.0196 19.7071 18.2071C19.5196 18.3946 19.2652 18.5 19 18.5H1C0.734784 18.5 0.48043 18.3946 0.292893 18.2071C0.105357 18.0196 0 17.7652 0 17.5V5.5C0 5.23478 0.105357 4.98043 0.292893 4.79289C0.48043 4.60536 0.734784 4.5 1 4.5H9ZM11 2.5V16.5H18V2.5H11ZM3 13.5H8V15.5H3V13.5ZM12 13.5H17V15.5H12V13.5ZM12 10.5H17V12.5H12V10.5ZM12 7.5H17V9.5H12V7.5ZM3 10.5H8V12.5H3V10.5Z"
            fill="#36F097"
        />
    </svg>
)

export const HammerSvg = () => (
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.7385 3.41626C14.9254 3.48429 15.0776 3.62379 15.1617 3.80407C15.2458 3.98434 15.2548 4.19063 15.1867 4.37754L13.9042 7.90139C13.8361 8.08831 13.6966 8.24054 13.5164 8.32461C13.3361 8.40867 13.1298 8.41768 12.9429 8.34965L9.41904 7.06707L6.08435 16.2291C6.01631 16.416 5.87682 16.5682 5.69654 16.6523C5.51626 16.7364 5.30998 16.7454 5.12306 16.6773L2.30398 15.6513C2.11707 15.5832 1.96483 15.4437 1.88077 15.2635C1.7967 15.0832 1.7877 14.8769 1.85573 14.69L5.19043 5.52798L1.31419 4.11715C1.12728 4.04912 0.975041 3.90962 0.890977 3.72934C0.806913 3.54907 0.797907 3.34278 0.865939 3.15586L1.47696 1.4771C1.52465 1.34628 1.60783 1.23132 1.71716 1.14509C1.8265 1.05886 1.95768 1.00478 2.09602 0.988891L6.63365 0.466337L14.7385 3.41626ZM10.7016 3.54322L6.45327 1.99695L2.72797 2.42568L2.53199 2.96412L7.11299 4.63147L3.52178 14.4982L4.93132 15.0113L8.52253 5.1445L9.93207 5.65753L10.7016 3.54322ZM13.5207 4.56928L12.1112 4.05625L11.3416 6.17056L12.7511 6.68359L13.5207 4.56928Z"
            fill="#999999"
        />
    </svg>
)

export const BranchSvg = () => (
    <svg
        width="12"
        height="17"
        viewBox="0 0 12 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6 0.161865L8.25 3.91187H6.75V9.44761L9 8.32337L8.99925 7.66187H8.25V4.66187H11.25V7.66187H10.4993L10.5 9.25037L6.75 11.1254V12.2901C7.6245 12.5991 8.25 13.4324 8.25 14.4119C8.25 15.6546 7.24275 16.6619 6 16.6619C4.75725 16.6619 3.75 15.6546 3.75 14.4119C3.75 13.5216 4.2675 12.7521 5.0175 12.3869L1.5 9.91187L1.49925 8.21087C1.0515 7.95137 0.75 7.46687 0.75 6.91187C0.75 6.08312 1.42125 5.41187 2.25 5.41187C3.07875 5.41187 3.75 6.08312 3.75 6.91187C3.75 7.46687 3.4485 7.95212 3 8.21087V9.16187L5.25 10.7264V3.91187H3.75L6 0.161865ZM6 13.6619C5.586 13.6619 5.25 13.9979 5.25 14.4119C5.25 14.8259 5.586 15.1619 6 15.1619C6.414 15.1619 6.75 14.8259 6.75 14.4119C6.75 13.9979 6.414 13.6619 6 13.6619Z"
            fill="#999999"
        />
    </svg>
)

export const AdcsSvg = () => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.8685 13.5589H13.6056V3.85297H3.8685V13.5589ZM10.3599 15.1765H7.1142V16.7941H5.49135V15.1765H3.05708C2.84187 15.1765 2.63548 15.0913 2.48331 14.9396C2.33114 14.7879 2.24565 14.5822 2.24565 14.3677V11.9412H0.622803V10.3236H2.24565V7.08827H0.622803V5.47062H2.24565V3.04415C2.24565 2.82963 2.33114 2.62391 2.48331 2.47222C2.63548 2.32054 2.84187 2.23532 3.05708 2.23532H5.49135V0.617676H7.1142V2.23532H10.3599V0.617676H11.9827V2.23532H14.417C14.6322 2.23532 14.8386 2.32054 14.9908 2.47222C15.143 2.62391 15.2284 2.82963 15.2284 3.04415V5.47062H16.8513V7.08827H15.2284V10.3236H16.8513V11.9412H15.2284V14.3677C15.2284 14.5822 15.143 14.7879 14.9908 14.9396C14.8386 15.0913 14.6322 15.1765 14.417 15.1765H11.9827V16.7941H10.3599V15.1765ZM5.49135 5.47062H11.9827V11.9412H5.49135V5.47062Z"
            fill="#9B72F2"
        />
    </svg>
)

export const PayloadSSDSvg = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.8685 13.5589H13.6056V3.85297H3.8685V13.5589ZM10.3599 15.1765H7.1142V16.7941H5.49135V15.1765H3.05708C2.84187 15.1765 2.63548 15.0913 2.48331 14.9396C2.33114 14.7879 2.24565 14.5822 2.24565 14.3677V11.9412H0.622803V10.3236H2.24565V7.08827H0.622803V5.47062H2.24565V3.04415C2.24565 2.82963 2.33114 2.62391 2.48331 2.47222C2.63548 2.32054 2.84187 2.23532 3.05708 2.23532H5.49135V0.617676H7.1142V2.23532H10.3599V0.617676H11.9827V2.23532H14.417C14.6322 2.23532 14.8386 2.32054 14.9908 2.47222C15.143 2.62391 15.2284 2.82963 15.2284 3.04415V5.47062H16.8513V7.08827H15.2284V10.3236H16.8513V11.9412H15.2284V14.3677C15.2284 14.5822 15.143 14.7879 14.9908 14.9396C14.8386 15.0913 14.6322 15.1765 14.417 15.1765H11.9827V16.7941H10.3599V15.1765ZM5.49135 5.47062H11.9827V11.9412H5.49135V5.47062Z"
            fill="#9B72F2" />
    </svg>
)

export const GpsSvg = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.73802 6.17949C7.78157 6.17949 6.19692 7.75967 6.19692 9.71062C6.19692 11.6616 7.78157 13.2418 9.73802 13.2418C11.6945 13.2418 13.2791 11.6616 13.2791 9.71062C13.2791 7.75967 11.6945 6.17949 9.73802 6.17949ZM17.6524 8.82784C17.2452 5.14663 14.3149 2.22461 10.6233 1.81853V0H8.85275V1.81853C5.16115 2.22461 2.23089 5.14663 1.82367 8.82784H0V10.5934H1.82367C2.23089 14.2746 5.16115 17.1966 8.85275 17.6027V19.4212H10.6233V17.6027C14.3149 17.1966 17.2452 14.2746 17.6524 10.5934H19.476V8.82784H17.6524ZM9.73802 15.8901C6.31201 15.8901 3.5411 13.127 3.5411 9.71062C3.5411 6.29425 6.31201 3.53113 9.73802 3.53113C13.164 3.53113 15.9349 6.29425 15.9349 9.71062C15.9349 13.127 13.164 15.8901 9.73802 15.8901Z"
            fill="#CC69C6"
        />
    </svg>
)

export const ThrusterSvg = () => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.42093 5.38891C3.45585 5.83288 1.9646 7.7993 1.9646 10.029C1.96458 11.231 2.40965 12.3898 3.21271 13.2786C4.01577 14.1674 5.11902 14.7222 6.30659 14.8345C7.49416 14.9467 8.68057 14.6084 9.63366 13.8857C10.5868 13.1629 11.2379 12.1078 11.4598 10.9268C11.5075 10.67 11.6156 10.4286 11.775 10.2226C11.9344 10.0166 12.1404 9.85209 12.3758 9.74282C12.7669 9.5613 13.1141 9.35608 13.4176 9.13531C12.7174 8.64228 12.4553 7.61288 13.0362 6.81813C13.5204 6.15816 13.901 5.4271 14.1648 4.65058C13.2103 5.09658 12.2132 5.44315 11.1888 5.68489C10.1657 5.93263 9.24806 5.16324 9.18802 4.2017C8.23063 4.66939 7.02091 5.02751 5.42093 5.38891ZM14.3425 7.78785C15.2885 7.78785 15.8978 7.44117 16.5688 7.3079C16.3051 8.49184 15.3518 10.1614 13.0557 11.2285C12.7605 12.8112 11.8895 14.2258 10.6133 15.1951C9.33716 16.1644 7.74781 16.6185 6.1567 16.4685C4.5656 16.3185 3.08742 15.5752 2.0118 14.3842C0.936185 13.1931 0.340657 11.6402 0.341906 10.0298C0.341906 7.04871 2.3435 4.40774 5.06719 3.79288C8.24848 3.075 9.69511 2.51247 10.8083 0.270508C11.3673 1.36042 11.3673 2.63511 10.8083 4.09459C13.093 3.54677 14.925 2.58033 16.3043 1.19362C16.3043 5.11991 14.8261 7.06915 14.3417 7.78785H14.3425Z"
            fill="#2679D7"
        />
    </svg>
)

export const PayloadObcSvg = () => (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 16.5V6.5H2V16.5H9ZM9 4.5V1.5C9 1.23478 9.10536 0.98043 9.29289 0.792893C9.48043 0.605357 9.73478 0.5 10 0.5H19C19.2652 0.5 19.5196 0.605357 19.7071 0.792893C19.8946 0.98043 20 1.23478 20 1.5V17.5C20 17.7652 19.8946 18.0196 19.7071 18.2071C19.5196 18.3946 19.2652 18.5 19 18.5H1C0.734784 18.5 0.48043 18.3946 0.292893 18.2071C0.105357 18.0196 0 17.7652 0 17.5V5.5C0 5.23478 0.105357 4.98043 0.292893 4.79289C0.48043 4.60536 0.734784 4.5 1 4.5H9ZM11 2.5V16.5H18V2.5H11ZM3 13.5H8V15.5H3V13.5ZM12 13.5H17V15.5H12V13.5ZM12 10.5H17V12.5H12V10.5ZM12 7.5H17V9.5H12V7.5ZM3 10.5H8V12.5H3V10.5Z"
            fill="#36F097" />
    </svg>
)

export const UploadModelSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g opacity="0.6">
            <path d="M28 20V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V20" stroke="#F0F0F0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22.6583 10.6667L15.9917 4L9.325 10.6667" stroke="#F0F0F0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 4V20" stroke="#F0F0F0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </g>
    </svg>
)

export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 22" fill="none">
        <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" stroke="#F0F0F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 8L8 14" stroke="#F0F0F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 8L14 14" stroke="#F0F0F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)